const CopyToClipboardPlugin = {
    install(app) {
        app.config.globalProperties.$copyToClipboard = function (value) {
            let $temp = document.createElement("input");
            document.body.appendChild($temp);
            $temp.value = value.trim();
            $temp.select();

            try {
                document.execCommand("copy");
            } catch (err) {
                console.error("Unable to copy", err);
            }

            document.body.removeChild($temp);
        };
    }
};

export default CopyToClipboardPlugin;